import { getOnboardingProgressQueryOptions } from '@eureca/candidate-api-sdk/hooks';
import type { RouterContext } from '@/routes/__root';
import { getKeycloak } from '@/auth/keycloak-instance';

/**
 * Onboarding progress only changes when a step is submitted, and every step
 * mutation explicitly invalidates `getOnboardingProgressQueryKey()`. Because the
 * shell gates (`RootRedirect`, `HomeGate`, `OnboardingLayout`) mount this query on
 * essentially every route — and each redirect hop remounts a fresh gate — the
 * default `staleTime: 0` made the BFF re-fetch `/onboarding/progress` on every
 * navigation hop and on every window focus. Keep it fresh long enough to dedupe
 * those mounts; correctness comes from the explicit invalidations, not polling.
 */
export const ONBOARDING_PROGRESS_STALE_TIME = 5 * 60 * 1000;

/**
 * EU-558 (reabertura): este loader é BEST-EFFORT e nunca rejeita.
 *
 * Um loader que rejeita cai no `defaultErrorComponent` do router — a tela
 * "Algo deu errado / Não foi possível carregar esta página", sem retry e sem
 * pista do que falhou. Como ele roda em ~20 rotas (entre elas as DUAS
 * superfícies de currículo), uma falha em `GET /onboarding/progress` derrubava
 * todas de uma vez: foi o que o suporte viu em produção — erro no perfil E nas
 * etapas, antes de qualquer interação com o arquivo.
 *
 * O progresso é dado de APOIO para os gates (`RootRedirect`, `HomeGate`,
 * `OnboardingLayout`), não a carga útil da página: cada um monta a própria
 * query e sabe lidar com ausência/erro. O papel do loader é só adiantar o
 * fetch — se não deu, a página segue e o gate resolve.
 *
 * A falha é logada porque a tela genérica não dizia nada a ninguém: nem ao
 * candidato, nem ao suporte.
 */
export function ensureOnboardingProgressLoaded(context: RouterContext) {
  if (!getKeycloak().authenticated) return undefined;
  return context.query
    .ensureQueryData({
      ...getOnboardingProgressQueryOptions(),
      staleTime: ONBOARDING_PROGRESS_STALE_TIME,
    })
    .catch((error: unknown) => {
      console.warn('[onboarding progress] prefetch falhou — a página segue sem ele', error);
      return undefined;
    });
}
